import React from 'react';
import './Loader.css';

const Loader = ({ visible, message = 'Please wait...' }) => {
  if (!visible) return null;

  return (
    <div className="global-loader-overlay" role="status" aria-live="polite">
      <div className="global-loader-card">
        <img src="/pragyaa-logo.png" alt="Pragyaa" className="global-loader-logo" />
        {message && <div className="global-loader-message">{message}</div>}
      </div>
    </div>
  );
};

export default Loader;
